export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20fashion%20product%20collage%20with%20sneakers%20hoodies%20accessories%20on%20warm%20cream%20background%2C%20clean%20aesthetic%2C%20editorial%20photography%2C%20gentle%20natural%20lighting%2C%20neutral%20beige%20and%20cream%20tones%2C%20soft%20shadows%2C%20artistic%20composition%2C%20elegant%20lifestyle%20flat%20lay%20with%20various%20fashion%20items%20arranged%20harmoniously&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="CSSBuy Spreadsheet fashion product collage"
          title="CSSBuy Spreadsheet Product Collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 lg:gap-16">
            <div className="lg:max-w-xl">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading text-background-50 leading-[1.08] tracking-tight">
                CSSBuy Spreadsheet
                <br />
                <span className="text-primary-300">The Most Updated</span>
                <br />
                Shopping List
              </h1>
              <p className="mt-6 text-sm md:text-base text-background-50/80 leading-relaxed max-w-md">
                Discover verified CSSBuy spreadsheets for sneakers, fashion, luxury items, and budget shopping. Compare top lists, updated daily.
              </p>
            </div>

            <div className="flex flex-col gap-3 lg:pb-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-primary-500 hover:bg-primary-400 text-background-50 font-medium text-sm rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                CSSBuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 font-medium text-sm rounded-full border border-background-50/30 transition-all whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 flex justify-center pb-6">
        <div className="flex items-center gap-8 md:gap-12 px-6 py-3 rounded-full bg-background-50/90 backdrop-blur-sm">
          {['Updated Daily', 'Verified Sources', 'Beginner Friendly', '100% Free'].map((badge) => (
            <span key={badge} className="text-xs md:text-sm text-foreground-700 font-medium whitespace-nowrap">
              <i className="ri-check-line text-primary-500 mr-1.5"></i>
              {badge}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}